import React from "react"
import Barcode from "react-barcode"
import { useTranslation } from "react-i18next"

import { scale } from "utils"

const PloptfcustomerBarcode = (props) => {
  const { templateType, printData } = props

  const { code } = printData

  const i18n = useTranslation()[1]

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(dir)
      : stylesOthers(dir)

  const barcodeHeight =
    templateType === "thermal" ? 45 / window.devicePixelRatio : 30

  const barcodeFontSize =
    templateType === "thermal" ? 25 : 11

  return (
    <div style={styles["container"]}>
      <Barcode
        fontSize={barcodeFontSize}
        height={barcodeHeight}
        displayValue={false}
        value={`${code}`}
      />
    </div>
  )
}

const stylesThermal = () => ({
  container: {
    display: "flex",
    justifyContent: "center",
    paddingTop: scale("10px")
  }
})

const stylesOthers = () => ({
  container: {
    marginRight: "8px",
    display: "flex",
    justifyContent: "center",
    paddingTop: "4px",
    fontSize: "11px"
  }
})

export default PloptfcustomerBarcode